interface AdminBannerProps {
  message: string | null
  variant: 'error' | 'success' | 'warning'
}

const VARIANT_STYLES: Record<AdminBannerProps['variant'], string> = {
  error: 'bg-red-50 border-red-200 text-red-600',
  success: 'bg-green-50 border-green-200 text-green-600',
  warning: 'bg-amber-50 border-amber-200 text-amber-700',
}

export function AdminBanner({ message, variant }: AdminBannerProps): JSX.Element | null {
  if (!message) return null

  const styles = VARIANT_STYLES[variant]

  return (
    <div className={`mb-4 rounded-lg border p-3 text-[13px] ${styles}`}>
      {message}
    </div>
  )
}
